export class FormErrorCode
{
	static EMPTY_PRODUCT_SELECTOR = 0;
	static EMPTY_IMAGE = 1;
	static EMPTY_QUANTITY = 2;
	static EMPTY_PRICE = 3;
	static EMPTY_BRAND = 4;
	static IS_NULLABLE_PRICE = 5;
}